<template>
  <div class="animateur-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-gray-800 uppercase">
        Animateurs
      </h2>

      <!-- Contenu principal -->
      <div class="prose max-w-4xl mx-auto text-justify leading-relaxed text-gray-800">
        <p class="text-lg mb-6">
          Il est possible de participer au projet <strong>« EITP en mission »</strong> et ainsi de s’engager à :
        </p>

        <ul class="list-disc list-inside mb-6 text-gray-700">
          <li class="mb-2">Suivre des sessions de formation pour la mission déterminée ;</li>
          <li class="mb-2">
            Animer des plates-formes sur les réseaux sociaux de l’École
            pour répondre aux diverses préoccupations de notre temps ;
          </li>
          <li class="mb-2">
            Animer des causeries ou des conférences sous la responsabilité de l’École,
            sur des thèmes précis préparés dans les ateliers de travaux,
            pour des paroisses, dans des groupes et associations.
          </li>
        </ul>

        <p class="mt-6 italic text-center text-gray-600 text-lg">
          Pour l’année 2020 - 2021, voir <strong>EITP en mission – Axe Animation</strong>.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AnimateurSection",
});
</script>

<style scoped>
.animateur-wrap {
  background-color: #fdfdfd;
}

.prose p {
  margin-bottom: 1rem;
}

ul li {
  margin-bottom: 0.5rem;
}
</style>
